import { NetworkClient } from '~/modules/RemoteMic/Network/Client/NetworkClient';

const client: NetworkClient = new NetworkClient();

export default client;
